<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnPrintVisible="false">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="toolbar">
            <print-component v-if="isBtnStampa" :documentRepository="true" :idRisorsa="idAccettazione"></print-component>
            <!-- <b-button size="sm" variant="btn--md btn-light waves-effect waves-light btn-toolbar  float-sm-right" @click="loadStampeReport" :hidden="isBtnStampa">
				<b-icon icon="printer"></b-icon>
				Stampa
			</b-button> -->
        </template>
        <template slot="table-body">
            <b-tabs id="tabsRsaAccettazioneEdit" ref="tabsRsaAccettazioneEdit" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
                <b-tab title="Anagrafica" id="tbAnagrafica" active>
                    <rsa-accettazione-anagrafica-view-component :isPageGestioneOspite="true" ref="cmpRsaAccettazioneAnagraficaViewComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></rsa-accettazione-anagrafica-view-component>
                </b-tab>
                <b-tab title="Persone di riferimento" id="tbPersoneRiferimento">
                    <rsa-persona-riferimento-component ref="cmpRsaPersonaRiferimento" :jsonData="jsonData"></rsa-persona-riferimento-component>
                </b-tab>
                <b-tab title="Impegnative (U.V.I.)" id="tbImpegnativa">
                    <rsa-accettazione-impegnativa-list-component ref="cmpRsaImpegnativaList" :idAccettazione="idAccettazione" :jsonData="jsonData"></rsa-accettazione-impegnativa-list-component>
                </b-tab>
                <b-tab title="Spese extra" id="tbSpeseExtra">
                    <rsa-spesa-extra-list-component ref="cmpRsaSpesaExtraList" :jsonDataAccettazione="jsonData"><!-- :utente="utente" --></rsa-spesa-extra-list-component>
                </b-tab>
                <b-tab title="Presenze/Uscite" id="tbPresenza">
                    <rsa-scheda-ospite-uscite-list-component ref="cmpRsaUsciteList" :jsonDataAccettazione="jsonData"></rsa-scheda-ospite-uscite-list-component>
                </b-tab>
                <b-tab title="Dati di Fatturazione" id="tbDatiFatturazione">
                    <rsa-accettazione-dati-fatturazione-list-component ref="cmpRsaAccettazioneDatiFatturazione"></rsa-accettazione-dati-fatturazione-list-component>
                </b-tab>

                <!--<b-tab title="Dimissione/Trasferimento" id="tbDimissioniTrasferimeti">
                    <rsa-scheda-ospite-dimissione-trasferimento-component ref="cmpRsaDimissioneTrasferimento" :jsonDataAccettazione="jsonData"></rsa-scheda-ospite-dimissione-trasferimento-component>
                </b-tab>-->
            </b-tabs>
            <print-component v-show="false" ref="cmpPrint"></print-component>
            <modal-error ref="cmpModalError"></modal-error>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaAccettazioneAnagraficaViewComponent from "../../rsaaccettazione/components/RsaAccettazioneAnagraficaViewComponent.vue";
import RsaPersonaRiferimentoComponent from "../../components/RsaPersonaRiferimentoComponent.vue";
import RsaAccettazioneImpegnativaListComponent from "../../rsaaccettazione/components/RsaAccettazioneImpegnativaListComponent.vue";
import RsaSpesaExtraListComponent from "../../rsaaccettazione/components/RsaSpesaExtraListComponent.vue";
import RsaSchedaOspiteUsciteListComponent from "../../rsagestioneospiti/components/RsaSchedaOspiteUsciteListComponent.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaAccettazioneDatiFatturazioneListComponent from "../../rsaaccettazione/components/RsaAccettazioneDatiFatturazioneListComponent.vue";
//import RsaSchedaOspiteDimissioneTrasferimentoComponent from "../../rsagestioneospiti/components/RsaSchedaOspiteDimissioneTrasferimentoComponent.vue";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        RsaAccettazioneDatiFatturazioneListComponent,
        ModalError,
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaAccettazioneAnagraficaViewComponent,
        RsaPersonaRiferimentoComponent,
        RsaAccettazioneImpegnativaListComponent,
        RsaSpesaExtraListComponent,
        RsaSchedaOspiteUsciteListComponent,
        PrintComponent,
        //      RsaSchedaOspiteDimissioneTrasferimentoComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/rsaaccettazioni",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            linkPrintData: "",
            listKey: 0,
            activeTabIndex: 0,
            isPageGestioneOspite: true,
            isBtnStampa: true,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.linkPrintData = "/rsaaccettazioni/printdata/" + me.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaAccettazioneAnagraficaViewComponent.setId(me.idAccettazione);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaAccettazioneEdit.getTabs()[index];

            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            me.isBtnStampa = false;
            switch (idActiveTab) {
                case "tbPersoneRiferimento":
                    me.$refs.cmpRsaPersonaRiferimento.loadData(me.idAccettazione);
                    break;
                case "tbImpegnativa":
                    me.$refs.cmpRsaImpegnativaList.loadData(me.idAccettazione);
                    break;
                case "tbSpeseExtra":
                    me.$refs.cmpRsaSpesaExtraList.setId(me.idAccettazione);
                    break;
                case "tbPresenza":
                    me.$refs.cmpRsaUsciteList.setId(me.idAccettazione);
                    break;
                case "tbAnagrafica":
                    me.$refs.cmpRsaAccettazioneAnagraficaViewComponent.setId(me.idAccettazione);
                    me.isBtnStampa = true;
                    break;
                case "tbDatiFatturazione":
                    me.$refs.cmpRsaAccettazioneDatiFatturazione.init(me.jsonData);
                    break;
                // case "tbDimissioniTrasferimeti":
                //     me.$refs.cmpRsaDimissioneTrasferimento.setId(me.idAccettazione);
                //     break;
            }
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        loadStampeReport() {
            let me = this;
            // me.printData = {};

            me.loadDataResources(me.linkPrintData, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;

            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            let me = this;
            let messaggio = error.response.messaggio ? error.response.messaggio : "Stampa non disponibile";
            me.$refs.cmpModalError.show(messaggio + "#");
        },
    },
};
</script>

<style></style>
